// extracted by mini-css-extract-plugin
export var arrowLeft = "feature-showcase-slider-module--arrowLeft--24117";
export var arrowRight = "feature-showcase-slider-module--arrowRight--a2c87";
export var contentCol = "feature-showcase-slider-module--contentCol--ed5ea";
export var ctaWrap = "feature-showcase-slider-module--ctaWrap--b532c";
export var description = "feature-showcase-slider-module--description--9926f";
export var desktop = "feature-showcase-slider-module--desktop--ba76d";
export var desktopImageCol = "feature-showcase-slider-module--desktopImageCol--4ac12";
export var fallbackMessage = "feature-showcase-slider-module--fallbackMessage--80c6e";
export var focusVisible = "feature-showcase-slider-module--focus-visible--f8d65";
export var headline = "feature-showcase-slider-module--headline--b78fb";
export var imageCol = "feature-showcase-slider-module--imageCol--78e87";
export var imageFrame = "feature-showcase-slider-module--imageFrame--30626";
export var imageWithArrows = "feature-showcase-slider-module--imageWithArrows--3e665";
export var inner = "feature-showcase-slider-module--inner--2991f";
export var mobile = "feature-showcase-slider-module--mobile--dc8d2";
export var mobileSlide = "feature-showcase-slider-module--mobileSlide--e62f0";
export var mobileSwiper = "feature-showcase-slider-module--mobileSwiper--24eef";
export var mobileSwiperWrapper = "feature-showcase-slider-module--mobileSwiperWrapper--06877";
export var richTextRoot = "feature-showcase-slider-module--richTextRoot--d8a77";
export var section = "feature-showcase-slider-module--section--7d210";
export var slideImage = "feature-showcase-slider-module--slideImage--53a2d";
export var tab = "feature-showcase-slider-module--tab--30200";
export var tabActive = "feature-showcase-slider-module--tabActive--c01ca";
export var tabInactive = "feature-showcase-slider-module--tabInactive--b6689";
export var tablist = "feature-showcase-slider-module--tablist--4949b";